import $ from 'jquery';

const NAVMENU = $( '#navmenu' );

function scrollTo ($el, hash) {
	let $target = $( hash );
	let $header = $( '.header' );
	let $current = NAVMENU.find( '.current-hash' );

	if ( $current.length ) {
		$current.removeClass( 'current-hash' )
	}

	$( 'html, body' ).animate( {
		scrollTop: $target.offset().top - $header.height()
	}, 600 );

	$el.addClass( 'current-hash' );
}

NAVMENU.on( 'click', 'a', e => {
	let href = e.currentTarget.getAttribute( 'href' );

	if ( href && href.startsWith( '/#' ) ) {
		let hash = href.replace( '/', '' );

		scrollTo( $( e.currentTarget ), hash );
		window.location.hash = hash;

		e.preventDefault();
	}
} );

$( document ).ready( () => {
	let hash = window.location.hash;

	if (! hash) return;

	let $el = NAVMENU.find( `a[href="/${hash}"]` )

	if ( $el.length ) {
		scrollTo( $el, hash );
	}
} );
